import {
  setConnectionTestResult,
  ConnectionTestResultAdditionalForTracking,
  type ConnectionTestResultForTracking,
} from '../../features/tracking/tracking.slice';
import {
  type ConnectionTestResult,
  ConnectionTestError,
} from '../../services/connectionTest';
import { useAppDispatch } from '../useReduxToolkit';

export type TrackConnectionTestResult = (
  error?: unknown,
  result?: ConnectionTestResult,
) => void;

const parseConnectionTestResultForTracking = (
  error?: unknown,
  result?: ConnectionTestResult,
): ConnectionTestResultForTracking => {
  if (error !== undefined) {
    return (error as { message?: string } | undefined)?.message ===
      ConnectionTestError.MediaDisabled
      ? ConnectionTestResultAdditionalForTracking.MediaError
      : ConnectionTestResultAdditionalForTracking.Error;
  }

  if (result) {
    return result;
  }

  return ConnectionTestResultAdditionalForTracking.NotCompleted;
};

export const useTrackConnectionTestResult = (): TrackConnectionTestResult => {
  const dispatch = useAppDispatch();

  return (error, result) => {
    const trackingResult = parseConnectionTestResultForTracking(error, result);

    dispatch(setConnectionTestResult(trackingResult));
  };
};
